import { useState, useRef } from "react";
import { CloudUpload, Folder2Open } from "react-bootstrap-icons";
import "./Upload.css";
import { VALID_EXTENSIONS, TOTAL_SIZE_LIMIT, formatSize } from "./Utils";

const FileDropZone = (props) => {
  const onFiles = props.onFiles;
  const multiple = props.multiple;
  const totalSize = props.totalSize || 0;
  const totalLimit = props.totalLimit || TOTAL_SIZE_LIMIT;
  const isOverLimit = totalSize > totalLimit;
  const hasFiles = totalSize > 0;

  const extensionHint = VALID_EXTENSIONS.map((ext) => `${ext}`)
    .join(" · ")
    .toUpperCase();
  const acceptHint = props.acceptHint || extensionHint;

  const [dragging, setDragging] = useState(false);
  const inputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onFiles(e.dataTransfer.files);
    }
  };

  const handleInputChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      onFiles(e.target.files);
      e.target.value = "";
    }
  };

  const fileAcceptValue = VALID_EXTENSIONS.map((ext) => `.${ext}`).join(",");
  const dropzoneClass =
    "upload-dropzone" +
    (dragging ? " is-dragging" : "") +
    (isOverLimit ? " is-over-limit" : "");

  return (
    <div
      className={dropzoneClass}
      onClick={() => {
        if (inputRef.current) inputRef.current.click();
      }}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <input
        ref={inputRef}
        type="file"
        multiple={multiple}
        style={{ display: "none" }}
        onChange={handleInputChange}
        accept={fileAcceptValue}
      />
      <div className="upload-dropzone__inner">
        <div className="upload-dropzone__icon">
          {dragging ? (
            <Folder2Open size={32} color="#1A1A2E" />
          ) : (
            <CloudUpload size={32} color={isOverLimit ? "#b02a37" : "#888"} />
          )}
        </div>
        <div className="upload-dropzone__title">
          {dragging ? "Release to add" : "Drop files here"}
        </div>
        <div className="upload-dropzone__subtitle">
          or <span className="upload-dropzone__browse-link">browse</span>
        </div>

        {isOverLimit ? (
          <>
            <div className="upload-dropzone__max_limit upload-dropzone__max_limit--danger">
              {formatSize(totalSize)} / {formatSize(totalLimit)}
            </div>
            <div className="upload-dropzone__overage">
              {formatSize(totalSize - totalLimit)} over limit
            </div>
          </>
        ) : hasFiles ? (
          <div className="upload-dropzone__max_limit">
            {formatSize(totalSize)} / {formatSize(totalLimit)}
          </div>
        ) : (
          <div className="upload-dropzone__max_limit">
            Total size: {formatSize(totalLimit)}
          </div>
        )}

        <div className="upload-dropzone__accept">{acceptHint}</div>
      </div>
    </div>
  );
};

export default FileDropZone;
